import GameLogoSvg from "../assets/img/Mushroots_poster.jpg";

export const ourGames = [
    {
        logo: GameLogoSvg,
        name: 'Mushroots',
        main_description: 'New RTS for everyone!' + `<br>` + `<br>` +
            'RTS have become more accessible! Tired of a bunch of units? Need a million clicks per second for low league? Time to try out a new game.',
        description:'MUSHROOTS is a new round in the world of the RTS genre. A variety of mechanics and different modes allow you to completely customize the game for yourself.' + '<br />' +
        'Take control of a race of intelligent mushrooms. Build a huge colonial system and lead your civilization to planetary domination.',
        date: 'MAY 2024',
        platforms: ['Windows', 'OSX', 'Linux'],
        test: `kar<br>akrkakrw`
    },
]